export const movies = [
  {
    id: "1001",
    title: "暗涌之城",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20rainy%20neon%20city%20at%20night%20with%20a%20lone%20detective%20silhouette%20walking%20down%20a%20narrow%20alley%2C%20deep%20blue%20and%20teal%20tones%2C%20moody%20cinematic%20lighting%2C%20heavy%20atmosphere%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1001&orientation=portrait",
    summary: "一桩尘封多年的旧案在一场暴雨后重新浮出水面。前刑警沈砺被迫回到那座他极力逃避的城市，在谎言与真相交织的暗涌中，他必须直面自己最不愿触碰的记忆。",
    director: "陈牧川",
    actors: ["沈砺", "林晚秋", "周维"],
    episodes: 1,
    duration: "128 分钟",
    views: 542000,
    addedAt: "2024-11-02",
  },
  {
    id: "1002",
    title: "星际回声",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20vast%20deep%20space%20scene%20with%20a%20lone%20spaceship%20gliding%20past%20a%20giant%20blue%20planet%2C%20glowing%20rings%20and%20nebula%2C%20deep%20navy%20and%20cyan%20tones%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1002&orientation=portrait",
    summary: "人类接收到来自深空的重复信号，一支由各国科学家组成的远征队踏上追寻之路。当飞船抵达信号源头，他们发现等待自己的，是关乎整个人类文明命运的抉择。",
    director: "Alexander Reed",
    actors: ["Elena Marsh", "Daniel Cole", "Marcus Vale"],
    episodes: 1,
    duration: "146 分钟",
    views: 892000,
    addedAt: "2023-07-18",
  },
  {
    id: "1003",
    title: "长夜将尽",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20of%20an%20elderly%20man%20standing%20alone%20facing%20a%20foggy%20harbor%20at%20dawn%2C%20muted%20blue%20and%20grey%20tones%2C%20warm%20distant%20lamplight%2C%20melancholic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1003&orientation=portrait",
    summary: "退休渔民老周执意要完成最后一次出海，只为把亡妻的骨灰撒在他们初识的那片海域。一次平静而漫长的航行，让他与疏离多年的儿子重新学会了告别与和解。",
    director: "许知远",
    actors: ["周海生", "许岚", "陈屿"],
    episodes: 1,
    duration: "112 分钟",
    views: 318000,
    addedAt: "2025-03-21",
  },
  {
    id: "1004",
    title: "雪线之上",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "冒险"],
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20of%20two%20climbers%20ascending%20a%20snowy%20mountain%20ridge%20at%20blue%20hour%2C%20vast%20white%20snow%20and%20deep%20blue%20sky%2C%20dramatic%20scale%2C%20cold%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1004&orientation=portrait",
    summary: "两名性格迥异的登山者在暴风雪来临前挑战无人登顶的雪峰。当身体与意志被一点点逼到极限，他们才明白真正的对手从来不是这座山。",
    director: "林岳",
    actors: ["高扬", "马骁", "苏晚"],
    episodes: 1,
    duration: "121 分钟",
    views: 276000,
    addedAt: "2022-09-30",
  },
  {
    id: "1005",
    title: "深海囚笼",
    type: "movie",
    year: 2024,
    region: "英国",
    genres: ["惊悚", "悬疑"],
    rating: 7.8,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20of%20a%20deep%20sea%20submersible%20illuminated%20by%20a%20single%20beam%20of%20light%20in%20dark%20turbulent%20water%2C%20deep%20indigo%20and%20black%20tones%2C%20tense%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1005&orientation=portrait",
    summary: "一支深海勘探队被困在万米海沟的失联潜水器中，氧气正在耗尽。随着越来越诡异的声响从舱外传来，队员之间开始怀疑彼此究竟还剩下多少人性。",
    director: "James Whitlock",
    actors: ["Harriet Lowe", "Tom Braden", "Iris Kane"],
    episodes: 1,
    duration: "104 分钟",
    views: 401000,
    addedAt: "2024-05-12",
  },
  {
    id: "1006",
    title: "春风信使",
    type: "movie",
    year: 2023,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20of%20a%20young%20woman%20holding%20letters%20on%20a%20spring%20street%20with%20cherry%20blossoms%20falling%2C%20soft%20blue%20and%20pink%20tones%2C%20gentle%20warm%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1006&orientation=portrait",
    summary: "小镇邮局的年轻投递员无意间读到一封写给十年前的信。她开始代替那些无法开口的人，把迟到的告白与道歉一封封送到收信人的春天里。",
    director: "佐藤悠介",
    actors: ["夏川凛", "宫本隼人", "森田澪"],
    episodes: 1,
    duration: "118 分钟",
    views: 365000,
    addedAt: "2023-10-06",
  },
  {
    id: "1007",
    title: "边境迷航",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科幻", "悬疑"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20series%20poster%20of%20a%20fog%20covered%20military%20outpost%20at%20the%20edge%20of%20a%20dark%20forest%20with%20searchlights%20cutting%20through%20mist%2C%20deep%20teal%20and%20navy%20tones%2C%20ominous%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1007&orientation=portrait",
    summary: "驻扎在边境观测站的研究员发现，每当浓雾降临，站外的世界就会出现无法解释的偏移。当补给线彻底中断，他们必须弄清楚——自己究竟还在地球的哪一边。",
    director: "Nathan Brooks",
    actors: ["Olivia Hart", "Ray Dalton", "Karen Voss"],
    episodes: 12,
    duration: "单集约 50 分钟",
    views: 731000,
    addedAt: "2024-08-15",
  },
  {
    id: "1008",
    title: "罪案凝视",
    type: "tv",
    year: 2023,
    region: "英国",
    genres: ["犯罪", "悬疑"],
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20series%20poster%20of%20a%20detective%20studying%20a%20wall%20of%20photographs%20and%20red%20strings%20in%20a%20dim%20office%20at%20night%2C%20deep%20blue%20and%20amber%20tones%2C%20tense%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1008&orientation=portrait",
    summary: "一位以冷静著称的犯罪侧写师，在追查连环案件时发现所有线索都指向自己尘封的过去。越是靠近真相，她越分不清被凝视的究竟是凶手，还是自己。",
    director: "Charlotte Hayes",
    actors: ["Amelia Grant", "Peter Rowe", "Diana Frost"],
    episodes: 10,
    duration: "单集约 55 分钟",
    views: 688000,
    addedAt: "2023-12-01",
  },
  {
    id: "1009",
    title: "时光邮局",
    type: "tv",
    year: 2025,
    region: "韩国",
    genres: ["爱情", "奇幻"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20romance%20series%20poster%20of%20an%20old%20post%20office%20filled%20with%20floating%20glowing%20letters%20and%20a%20warm%20lamp%2C%20deep%20blue%20and%20soft%20gold%20tones%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1009&orientation=portrait",
    summary: "一间只在午夜营业的邮局，可以把信件寄往过去。年轻的临时邮差在整理信件时，意外发现了写给自己的那封——寄信日期，是十年之后。",
    director: "金志勋",
    actors: ["韩素妍", "李道允", "车敏书"],
    episodes: 16,
    duration: "单集约 45 分钟",
    views: 596000,
    addedAt: "2025-02-14",
  },
  {
    id: "1010",
    title: "山河故人录",
    type: "chinese-drama",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "历史"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20historical%20drama%20poster%20of%20a%20solitary%20general%20in%20flowing%20robes%20overlooking%20misty%20mountains%20at%20dusk%2C%20deep%20blue%20and%20ink%20black%20tones%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1010&orientation=portrait",
    summary: "乱世之中，一介寒门书生凭一支笔踏入朝堂。他在权谋与理想的夹缝中步步为营，最终却发现，所谓山河，不过是一代代人来不及写完的故人录。",
    director: "孔令仪",
    actors: ["萧砚", "温之澜", "顾长风"],
    episodes: 45,
    duration: "单集约 45 分钟",
    views: 812000,
    addedAt: "2024-06-20",
  },
  {
    id: "1011",
    title: "都市浮生记",
    type: "chinese-drama",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感"],
    rating: 8.1,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20modern%20urban%20drama%20poster%20of%20a%20young%20professional%20standing%20on%20a%20glass%20skyscraper%20rooftop%20looking%20over%20a%20night%20city%20of%20blue%20lights%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1011&orientation=portrait",
    summary: "合租在同一层公寓里的五个年轻人，各自怀揣着不被理解的梦想。在房价、职场与感情的反复拉扯中，他们学着在拥挤的城市里为彼此留一盏灯。",
    director: "唐立",
    actors: ["苏念", "陆则", "方圆"],
    episodes: 36,
    duration: "单集约 42 分钟",
    views: 452000,
    addedAt: "2025-04-09",
  },
  {
    id: "1012",
    title: "长安十二时",
    type: "chinese-drama",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "权谋"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20palace%20intrigue%20poster%20of%20a%20lantern%20lit%20old%20city%20street%20at%20night%20with%20guards%20and%20tall%20palace%20walls%2C%20deep%20blue%20and%20crimson%20accents%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1012&orientation=portrait",
    summary: "上元灯节前夜，一桩刺杀阴谋在繁华的长安城内悄然铺开。负责守城的年轻校尉只有十二个时辰，去寻找那个藏在花灯与人潮背后的真相。",
    director: "黎鸣",
    actors: ["裴瑾", "沈清欢", "李承晏"],
    episodes: 40,
    duration: "单集约 45 分钟",
    views: 703000,
    addedAt: "2023-11-11",
  },
  {
    id: "1013",
    title: "归途列车",
    type: "chinese-drama",
    year: 2022,
    region: "中国大陆",
    genres: ["家庭", "剧情"],
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20of%20a%20passenger%20train%20crossing%20a%20snowy%20countryside%20at%20dusk%20seen%20through%20a%20window%2C%20deep%20blue%20and%20soft%20warm%20tones%2C%20nostalgic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1013&orientation=portrait",
    summary: "一列横穿南北的绿皮火车上，三组素不相识的旅客因为一场大雪被迫同行。漫长的旅途里，每个人都带着各自不愿提起的想念，驶向同一个故乡。",
    director: "范晓",
    actors: ["何庆", "梁静宜", "罗川"],
    episodes: 30,
    duration: "单集约 44 分钟",
    views: 289000,
    addedAt: "2022-08-26",
  },
  {
    id: "1014",
    title: "迷雾小镇",
    type: "overseas-drama",
    year: 2024,
    region: "美国",
    genres: ["悬疑", "惊悚"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%20of%20a%20small%20foggy%20town%20with%20a%20lonely%20road%20and%20dim%20street%20lamps%2C%20pine%20forest%20in%20mist%2C%20deep%20blue%20and%20grey%20tones%2C%20eerie%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1014&orientation=portrait",
    summary: "每逢大雾，小镇就会有人失踪，而回来的人都不再记得离开过。新来的女警探试图揭开这层迷雾，却发现自己正一点点走进一个为所有人准备好的局。",
    director: "Gregory Ellis",
    actors: ["Nora Blaine", "Ethan Cross", "Mia Vane"],
    episodes: 8,
    duration: "单集约 52 分钟",
    views: 574000,
    addedAt: "2024-10-03",
  },
  {
    id: "1015",
    title: "极光之下",
    type: "overseas-drama",
    year: 2023,
    region: "挪威",
    genres: ["剧情", "冒险"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Nordic%20drama%20poster%20of%20a%20small%20wooden%20cabin%20under%20green%20and%20blue%20aurora%20over%20a%20frozen%20fjord%2C%20vast%20night%20sky%2C%20deep%20blue%20tones%2C%20ethereal%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1015&orientation=portrait",
    summary: "一名地质学家带着女儿搬到北极圈附近的小镇，想要重新开始生活。在极昼与极夜的交替中，他们慢慢读懂了彼此沉默背后的孤独与牵挂。",
    director: "Ingrid Solberg",
    actors: ["Astrid Holm", "Jonas Berg", "Liv Dahl"],
    episodes: 6,
    duration: "单集约 50 分钟",
    views: 342000,
    addedAt: "2023-09-14",
  },
  {
    id: "1016",
    title: "东京夜行",
    type: "overseas-drama",
    year: 2025,
    region: "日本",
    genres: ["都市", "悬疑"],
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20mystery%20series%20poster%20of%20a%20rainy%20Tokyo%20street%20at%20night%20with%20neon%20reflections%20and%20a%20lone%20figure%20with%20umbrella%2C%20deep%20blue%20and%20magenta%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1016&orientation=portrait",
    summary: "深夜电台主播每晚都会接到一个匿名来电，讲述着城市里不为人知的秘密。当其中一个故事与她的过去重叠，她决定在黎明之前找到那个打电话的人。",
    director: "山田和也",
    actors: ["中村绫", "高桥陆", "小林凛"],
    episodes: 11,
    duration: "单集约 46 分钟",
    views: 388000,
    addedAt: "2025-05-30",
  },
  {
    id: "1017",
    title: "疯狂的厨房",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "真人秀"],
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Variety%20show%20poster%20of%20a%20lively%20open%20kitchen%20with%20chefs%20cooking%20and%20steam%20rising%2C%20warm%20amber%20and%20deep%20blue%20accents%2C%20fun%20energetic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1017&orientation=portrait",
    summary: "八位来自天南海北的厨师，在一间随时会停电的破旧厨房里限时对决。没有华丽摆盘，只有最真实的手忙脚乱和热气腾腾的烟火气。",
    director: "综艺制作组",
    actors: ["常驻嘉宾阵容"],
    episodes: 12,
    duration: "单期约 90 分钟",
    views: 421000,
    addedAt: "2024-07-05",
  },
  {
    id: "1018",
    title: "声音的旅行",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20on%20stage%20surrounded%20by%20blue%20spotlights%20and%20sound%20waves%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1018&orientation=portrait",
    summary: "来自不同城市的素人歌者，用一首歌讲述一段属于自己的旅程。舞台之上没有评委打分，只有观众在旋律落下时最真实的掌声与眼泪。",
    director: "综艺制作组",
    actors: ["竞演歌手阵容"],
    episodes: 10,
    duration: "单期约 100 分钟",
    views: 507000,
    addedAt: "2023-08-19",
  },
  {
    id: "1019",
    title: "荒野求生记",
    type: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["户外", "真人秀"],
    rating: 7.9,
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20survival%20show%20poster%20of%20a%20campfire%20and%20tent%20in%20a%20wild%20mountain%20valley%20at%20night%20under%20stars%2C%20deep%20blue%20and%20warm%20orange%20glow%2C%20rugged%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1019&orientation=portrait",
    summary: "六位明星被丢进无人山区，只带着三天口粮和一台摄像机。他们要自己找水、生火、搭棚，在真实的荒野里重新认识“生存”两个字。",
    director: "综艺制作组",
    actors: ["野外挑战团"],
    episodes: 9,
    duration: "单期约 85 分钟",
    views: 276000,
    addedAt: "2025-06-12",
  },
  {
    id: "1020",
    title: "星海旅人",
    type: "anime",
    year: 2024,
    region: "日本",
    genres: ["科幻", "冒险"],
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Anime%20sci%20fi%20poster%20of%20a%20young%20space%20traveler%20standing%20on%20a%20cliff%20of%20a%20floating%20island%20facing%20a%20colorful%20star%20filled%20sky%2C%20deep%20blue%20and%20cyan%20tones%2C%20vibrant%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1020&orientation=portrait",
    summary: "在群星坠落的时代，少年带着一枚会发光的罗盘踏上旅途。他要穿过整片星海，去寻找传说中那艘从未归航的飞船，以及船上消失的家人。",
    director: "新谷澄",
    actors: ["声优阵容"],
    episodes: 24,
    duration: "单集约 24 分钟",
    views: 934000,
    addedAt: "2024-01-08",
  },
  {
    id: "1021",
    title: "墨色江湖",
    type: "anime",
    year: 2023,
    region: "中国大陆",
    genres: ["武侠", "热血"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20wuxia%20poster%20of%20a%20swordsman%20mid%20leap%20above%20a%20misty%20bamboo%20forest%20with%20ink%20splashes%2C%20deep%20blue%20and%20ink%20black%20tones%2C%20dynamic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1021&orientation=portrait",
    summary: "江湖传言，得墨色剑者得天下。少年剑客为查明师门血案真相踏入纷争，却在刀光剑影中渐渐懂得，真正的江湖从来不在剑上，而在人心。",
    director: "水墨动画工作室",
    actors: ["配音阵容"],
    episodes: 20,
    duration: "单集约 22 分钟",
    views: 645000,
    addedAt: "2023-05-20",
  },
  {
    id: "1022",
    title: "灵狐物语",
    type: "anime",
    year: 2025,
    region: "中国大陆",
    genres: ["奇幻", "治愈"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%20of%20a%20white%20nine%20tailed%20fox%20spirit%20by%20a%20lakeside%20pavilion%20at%20moonlit%20night%20with%20fireflies%2C%20deep%20blue%20and%20soft%20teal%20tones%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1022&orientation=portrait",
    summary: "化形千年的灵狐为了修行圆满，来到人间小镇开了一间茶铺。她本以为只是短短一载，却在来来往往的客人与四季里，慢慢学会了舍不得。",
    director: "青竹动画组",
    actors: ["配音阵容"],
    episodes: 18,
    duration: "单集约 23 分钟",
    views: 512000,
    addedAt: "2025-07-01",
  },
  {
    id: "1023",
    title: "机械纪元",
    type: "anime",
    year: 2022,
    region: "日本",
    genres: ["机甲", "科幻"],
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Anime%20mecha%20poster%20of%20a%20giant%20blue%20robot%20standing%20in%20a%20ruined%20futuristic%20city%20at%20night%20with%20glowing%20cores%2C%20deep%20blue%20and%20steel%20grey%20tones%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1023&orientation=portrait",
    summary: "在被机械统治的未来，一名少年意外唤醒了沉睡百年的最后一台人形机甲。他必须驾驶它与命运对抗，去守护人类仅存的那座天空之城。",
    director: "神谷彻",
    actors: ["声优阵容"],
    episodes: 25,
    duration: "单集约 24 分钟",
    views: 468000,
    addedAt: "2022-04-10",
  },
  {
    id: "1024",
    title: "晴天和雨天",
    type: "anime",
    year: 2024,
    region: "日本",
    genres: ["日常", "治愈"],
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20anime%20poster%20of%20a%20girl%20with%20umbrella%20on%20a%20quiet%20town%20street%20after%20rain%20with%20reflections%2C%20soft%20blue%20and%20mint%20tones%2C%20gentle%20warm%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-1024&orientation=portrait",
    summary: "转学生小晴总在雨天忘记带伞，而同桌小宇的包里永远备着两把。一个关于借伞与还伞的温柔故事，在四季的阴晴里慢慢长出喜欢的形状。",
    director: "小林夏树",
    actors: ["声优阵容"],
    episodes: 13,
    duration: "单集约 23 分钟",
    views: 589000,
    addedAt: "2024-04-05",
  },
];